<template>
  <div>
    <el-form
      :model="listForm"
      ref="listForm"
      :rules="releaseRules"
      class="editForm"
      label-width="170px"
    >
      <el-row>
        <el-col :span="12" >
          <el-form-item label="纳税专户名称" prop="taxCompanyName">
            <el-input v-model="listForm.taxCompanyName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="taxpayerIdNum">
            <el-input v-model="listForm.taxpayerIdNum" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属机构" prop="orgId">
            <el-select v-model="listForm.orgId" placeholder="请选择机构">
              <el-option
                v-for="item in cusOrgList"
                :key="item.id"
                :label="item.orgName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="企业所属行政区" prop="wageAreaCode">
            <bsp-dicts-cascader
              v-model="listForm.wageAreaCode"
              :cascader-value.sync="listForm.wageAreaCode"
              :areaCode.sync="listForm.wageAreaCode"
							 :props="{ checkStrictly: true }"
              dic-num="1026"
              @change="areaCodeNameChange"
            >
            </bsp-dicts-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="行政区划码" prop="areaCode">
            <el-input v-model="listForm.areaCode" readonly />
<!--            <el-select v-model="listForm.areaCode" filterable placeholder="请选择">
              <el-option v-for="item in this.dicts.codeList[9255]"
                         :key="item.codeItemId"
                         :value="item.codeItemId"
                         :label="item.codeItemName"
              ></el-option>
            </el-select>-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报税实名账号" prop="realnameAccount">
            <el-input v-model="listForm.realnameAccount" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实名密码" prop="realnamePwd">
            <el-input v-model="listForm.realnamePwd" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主管税务机关登记序号" prop="registNum">
            <el-input v-model="listForm.registNum" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="网税系统用户名" prop="nettaxUsername">
            <el-input v-model="listForm.nettaxUsername" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申报密码" prop="taxDeclaePwd">
            <el-input v-model="listForm.taxDeclaePwd" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子报税账户号" prop="taxDeclaeAccount">
            <el-input v-model="listForm.taxDeclaeAccount" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="税金申报方式" prop="taxDeclareMethod">
            <bsp-dicts-select
              v-model="listForm.taxDeclareMethod"
              ref = "taxDeclareMethod"
              dic-num="9256"
              :select-value.sync="listForm.taxDeclareMethod"
              @selectChange="selectChangeTax"
              placeholder="请选择税金申报方式"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否分部门" prop="isDept">
            <bsp-dicts-select
              v-model="listForm.isDept"
              ref = "isDept"
              dic-num="1002"
              :select-value.sync="listForm.isDept"
              @selectChange="selectChange"
              placeholder="请选择是否分部门"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="isDeptNum">
          <el-form-item label="部门编号" prop="deptNum" :rules="[
              { required: true, message: '部门编号不能为空'},
            ]" >
            <el-input v-model="listForm.deptNum" />
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <el-form-item label="备注" prop="remark"  >
            <el-input type="textarea" :rows="2" v-model="listForm.remark" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import bspSelectTree from "@/components/bsp/bsp-select-tree/bsp-select-tree";
import bspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
import bspDictsCascader from "@/components/bsp/bsp-dicts-cascader/bsp-dicts-cascader";
import { isvalidatemobile, cardid } from "@/util/validate";
import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
import { init,codeList,codeToName,nameToCode,getCodeNames,getNameCodes} from "@/components/bsp/code/frontCode";
import { mapGetters } from 'vuex';
import {getCompanyOrg} from "@/api/org/org";
import store from "@/store";
import {getCodeTreeByCodeSetIdAndCusId} from "@/api/common/common";
import { deepCopy } from "@/util/util";


export default {
  components: {
    CiicTreeSelect,
    isvalidatemobile,
    cardid,
    bspDictsSelect,
    bspSelectTree,
    bspDictsCascader
  },
  computed: {
    ...mapGetters([
      'dicts',
    ]),
  },
  name: "Dialog",
  props: {
    listForm: {
      type: Object,
      default: () => ({})
    },
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: ""
    }
  },
  watch: {
    listForm: {
      handler(newVal, oldVal) {
        // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
        this.$emit("update:listForm", newVal);
      },
      immediate: true,
      deep: true
    },
  },
  created() {
    this._getCompanyOrg();
    init('city');
    /*console.log("行政区划：",cityList);
    console.log("行政区划：",codeToName);
    console.log("行政区划：",codeToName[ "120000", "120100", "120101"]);
    console.log("行政区划fanyi1：",getCodeNames("120000,120100,120101"));
    console.log("行政区划fanyi2：",getNameCodes("北京市,北京市,昌平区"));
    console.log("行政区划：",nameToCode);*/
  },
  mounted() {},
  data() {
    const validateIdcard = (rule, value, callback) => {
      if (this.listForm.idType == "00340001") {
        if (cardid(value)[0]) {
          callback(new Error(cardid(value)[1]));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      options: codeList,
      selectedOptions: [],
      disabled: true,
      showCropAvatar: false,
      photo: "",
      releaseRules: {
        taxCompanyName: [{ required: true, message: "纳税专户名称不能为空", trigger: "blur" },
        { max:20, message: '不能超过20个字符', trigger:"blur"}],
        // 引用基本的 校验
        idType: [{ required: true, message: "证件类型不能为空", trigger: "blur" }],
        orgId: [{ required: true, message: "所属机构不能为空", trigger: "blur" }],
        taxpayerIdNum: [{ required: true, message: "纳税人识别号不能为空", trigger: "blur" },
        { max:20, message: '不能超过20个字符', trigger:"blur"}],
        realnameAccount: [{ required: true, message: "报税实名账号不能为空", trigger: "blur" },
        { max:20, message: '不能超过20个字符', trigger:"blur"}],
        realnamePwd: [{ required: true, message: "实名密码不能为空", trigger: "blur" },
        { max:20, message: '不能超过20个字符', trigger:"blur"}],
        registNum: [{ max:20, message: '不能超过20个字符', trigger:"blur"}],
        wageAreaCode: [{ required: true, message: "企业所属区行政区划不能为空", trigger: "blur" }],
        areaCode: [{ required: true, message: "行政区划代码不能为空", trigger: "blur" }],
        isDept: [{ required: true, message: "是否分部门不能为空", trigger: "blur" }],
        nettaxUsername:[{ max:20, message: '不能超过20个字符', trigger:"blur"}],
        taxDeclaePwd:[{ max:20, message: '不能超过20个字符', trigger:"blur"}],
        taxDeclaeAccount:[{ max:20, message: '不能超过20个字符', trigger:"blur"}],
        remark: [{ max:20, message: '备注不能超过200个字符', trigger:"blur"}],
      },
      sexList: [{ value: "1", label: "女" }, { value: "2", label: "男" }],
      props: {
        // 配置项（必选）
        value: "id",
        label: "orgName",
        children: "children"
      },
      cusOrgList: [],
      valueId: null,
      isDeptNum:false,
    };
  },
  methods: {
    //区划分级联事件
    areaCodeNameChange(value){

      // this.listForm.areaCode = value&&value.length>1?value[1]:value[0];
      // alert(+this.listForm.areaCode)
      let name = '';
      const id = value[value.length - 1];
      const list = this.dicts.codeList[1026] || [];

      for (let i = 0; i < list.length; i++) {
        if (list[i].codeItemId == id) {
          name = list[i].codeItemName;
          break; // 找到就跳出，和 find 行为一致
        }
      }
      for (const item of this.dicts.codeList[9255] || []) {
        if (item.codeItemName == name) {
          this.listForm.areaCode = item.codeItemId;
          break;
        }
      }

    },
    //查询分公司
    _getCompanyOrg() {
      getCompanyOrg(store.getters.cusId).then((res) => {
        this.cusOrgList = res.data
      });
    },
    toggleShowCropAvatar() {
      this.showCropAvatar = !this.showCropAvatar;
    },
    handleUploadSuccess(res, field) {
      console.log(res);
      this.listForm.photo = res.fileId;
    },
    // 取值
    getValue(value){
        this.valueId = value
    },
    handleChange(v){},
    selectChange(value){
      this.listForm.isDept = value
      if(value=='10020001'){
        this.isDeptNum=true
      }else{
        let newList = deepCopy(this.listForm);
        newList.deptNum='';
        this.$emit("update:listForm", newList);
        this.isDeptNum=false
      }
    },
    selectChangeTax(value){
      this.listForm.taxDeclareMethod = value
    },
  }
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-left: 30px;
  margin-bottom: 5px;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
  margin-left: 30px;
  margin-bottom: 5px;
}
</style>
